import { List, ListItem, ListItemText, withStyles } from "@material-ui/core";
import React from "react";
import style from "style";
import Item from ".";
import { useHistory } from "react-router";
import { LINK_TYPE_INTERNAL } from "../menus";

const MainSectionItemTitle = ({ classes, title, subItems, ...other }) => {
  const navigate = useHistory();
  return (
    <div>
      <div
        onClick={() => {
          if (other.link) {
            if (other.linkType === LINK_TYPE_INTERNAL) {
              navigate.push(other.link);
            } else {
              window.location.replace(other.link);
            }
            other.onClick();
          }
        }}
      >
        <ListItem
          className={classes.mainNavTitle}
          style={{
            cursor: other.link ? "pointer" : "default",
          }}
        >
          <ListItemText primary={title} />
        </ListItem>
      </div>
      {/* children here */}
      <div style={{ textIndent: "1rem" }}>
        {subItems.map((item) => {
          return <Item {...item} {...other} />;
        })}
      </div>
    </div>
  );
};

export default withStyles(style)(MainSectionItemTitle);
